import React from 'react';
import { ILenderCompanyData } from '../../types/lenders/ILenderCompany';
import { BodyText, DataGrid, NavigationItem } from '../../ui-toolkit/components';
import { IBootstrapTableColumnProps } from 'react-bootstrap-table-next';
import { propertyAddressToString } from '../../types/address/IPropertyAddressData';
import { ClientUrlFactory } from '../../ui-toolkit/rest/ClientUrlFactory';
import { SwitchLenderCompanyActivateButton } from './SwitchLenderCompanyActivateButton';

interface ILenderCompaniesTableProps {
  data: ILenderCompanyData[];
  isLoading: boolean;
}

const columns: IBootstrapTableColumnProps<ILenderCompanyData>[] = [
  {
    dataField: 'name',
    text: 'Name',
    sort: true,
    headerStyle: { width: '25%' },
    classes: (cell, row) => `name-column-${row.id}`,
  },
  {
    dataField: 'masterEmail',
    text: 'Master Email',
    headerStyle: { width: '25%' },
    formatter: (_, row) => (
      <NavigationItem
        text={row?.masterEmail ? row.masterEmail : ''}
        href={`mailto:${row?.masterEmail ? row.masterEmail : ''}`}
        isActive
      />
    ),
    classes: (cell, row) => `master-email-column-${row.id}`,
  },
  {
    dataField: 'address',
    text: 'Address',
    headerStyle: { width: '25%' },
    formatter: (_, row) => <BodyText>{row?.address ? propertyAddressToString(row.address) : ''}</BodyText>,
    classes: (cell, row) => `address-column-${row.id}`,
  },
  {
    dataField: 'id',
    text: 'Actions',
    headerStyle: { width: '25%' },
    formatter: (_, row) => (
      <BodyText>
        <NavigationItem text={'View'} isInline to={ClientUrlFactory().urlFor.lenderCompany(row.id)} />
        {` | `}
        <NavigationItem text={'Edit'} isInline to={ClientUrlFactory().urlFor.lenderCompanyEdit(row.id)} />
        <SwitchLenderCompanyActivateButton lenderCompany={row} />
      </BodyText>
    ),
    classes: (cell, row) => `actions-column-${row.id}`,
  },
];

export const LenderCompaniesTable: React.FC<ILenderCompaniesTableProps> = ({ data, isLoading }) => (
  <DataGrid
    columns={columns}
    keyField={'id'}
    data={data}
    defaultSorted={[{ dataField: 'name', order: 'asc' }]}
    loading={isLoading}
  />
);
